import { render, staticRenderFns } from "./CalculateTabsBri.vue?vue&type=template&id=25cc8450&scoped=true"
import script from "./CalculateTabsBri.vue?vue&type=script&lang=js"
export * from "./CalculateTabsBri.vue?vue&type=script&lang=js"
import style0 from "./CalculateTabsBri.vue?vue&type=style&index=0&id=25cc8450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cc8450",
  null
  
)

export default component.exports